module.exports = __webpack_public_path__ + "media/images/up_arrow-f0f1f41c44ae3104ce4a626c9aad0d6c.png";